import { useQuery } from '@tanstack/react-query';

import { listOfferBypassRegionFilterSettings } from '~/services/PromoService';

import { offerBypassRegionFilterQueryKeys } from './offerBypassRegionFilterQueryKeys';

type Params = {
  query: Parameters<typeof listOfferBypassRegionFilterSettings>[0];
  enabled?: boolean;
};

export function useListOfferBypassRegionFilterSettings({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: offerBypassRegionFilterQueryKeys.list(query),
    queryFn: async ({ signal }) => listOfferBypassRegionFilterSettings(query, { signal }),
    enabled,
  });
}
